import { AppProvider } from '@/context/AppContext'
import { type Apps } from '@/dtos'
import { Outlet } from 'react-router'

export interface LeasingBaseLayoutProps {
  app: Apps | null
}

export const LeasingBaseLayout = (props: LeasingBaseLayoutProps) => {
  return (
    <AppProvider app={props.app}>
      <Outlet />
    </AppProvider>
  )
}